<template>
  <div>
    <v-btn v-if="false" fab depressed color="primary" small :to="`/regalos`"><v-icon>mdi-chevron-left</v-icon></v-btn>

    <!-- breadcrumb -->
    <div style="display: flex; justify-content: space-between; align-items: center">
      <router-link :to="`/regalos/`"> <v-icon>mdi-chevron-left</v-icon>Regalos</router-link>

      <!-- menu -->
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab depressed small color="success" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list style="border-radius: 12px">
          <v-list-item @click="goToEdit">
            <v-list-item-title>Editar campaña</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <h1>{{ campaign.title }} <span v-if="false" class="modern-link" @click="goToEdit">editar</span></h1>
    <p v-if="campaign.description">{{ campaign.description }}</p>

    <div v-if="campaign">
      <v-chip-group>
        <v-chip>Gestionado: {{ completedCount }}</v-chip>
        <v-chip>Gastado: {{ completedSumSpend }}€</v-chip>

        <v-chip>Budget: {{ campaign.budget }}€</v-chip>
      </v-chip-group>
    </div>

    <div>
      <v-checkbox v-model="campaign.completed" label="Completado"></v-checkbox>
    </div>

    <div v-if="campaign && campaign.ideas">
      <!-- comprado -->
      <div v-if="campaign.ideas.filter((i) => i.completed).length">
        <h2>Gestionado</h2>
        <div v-for="idea in campaign.ideas.filter((i) => i.completed)" :key="idea.id">
          <IdeaListItem :idea="idea" :campaign="campaign" />
        </div>
      </div>
      <!-- pendiente -->
      <div style="margin-top: 40px" v-if="campaign.ideas.filter((i) => !i.completed && !i.discarded).length">
        <h2>Pendiente</h2>
        <div v-for="idea in campaign.ideas.filter((i) => !i.completed && !i.discarded)" :key="idea.id">
          <IdeaListItem :idea="idea" :campaign="campaign" />
        </div>
      </div>

      <!-- descartado -->
      <div style="margin-top: 40px" v-if="campaign.ideas.filter((i) => i.discarded).length">
        <h2>Descartado</h2>
        <div v-for="idea in campaign.ideas.filter((i) => i.discarded)" :key="idea.id">
          <IdeaListItem :idea="idea" :campaign="campaign" />
        </div>
      </div>
    </div>

    <!-- cuentas -->
    <div v-if="campaign && campaign.split_spend" style="margin-top: 20px">
      <h2>Cuentas</h2>

      <div>
        <v-chip class="ma-1" v-for="(value, person) in spentPerPerson" :key="person">
          {{ person }}: {{ value }}
        </v-chip>
      </div>
    </div>

    <div style="height: 40px"></div>

    <!--add button-->
    <v-fab-transition>
      <v-btn fab bottom right fixed color="success" @click="addIdea" :loading="loading" style="margin-bottom: 56px">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import api from '@/assets/api'
import { v4 as uuidv4 } from 'uuid'

import IdeaListItem from './IdeaListItem.vue'
import { friends } from './regalos-data'

export default {
  components: {
    IdeaListItem,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      campaign: {},
      loading: false,
    }
  },
  watch: {
    campaign: {
      deep: true,
      handler(newValue, oldValue) {
        //only if there was a previous value  (i.e. not first load)
        if (oldValue.id) {
          this.save()
        }
      },
    },
  },
  computed: {
    friendsList() {
      return friends([this.campaign], this.username)
    },
    spentPerPerson() {
      const spent = {}

      if (!this.campaign || !this.campaign.ideas) return spent
      for (let i = 0; i < this.campaign.ideas.length; i++) {
        const idea = this.campaign.ideas[i]
        for (let j = 0; j < idea.options.length; j++) {
          const option = idea.options[j]

          if (option.purchased) {
            const payer = option.paidBy || 'Nadie'
            const payerName = this.friendsList.find((f) => f.username === payer)?.name || payer
            if (!spent[payerName]) spent[payerName] = 0
            spent[payerName] += +option.price
          }
        }
      }
      //round to 2 decimals
      for (const person in spent) {
        spent[person] = (Math.round(spent[person] * 100) / 100).toFixed(2)
      }
      return spent
    },
    completedSumSpend() {
      let total = 0
      if (!this.campaign || !this.campaign.ideas) return 0
      for (let i = 0; i < this.campaign.ideas.length; i++) {
        const idea = this.campaign.ideas[i]
        if (!idea.completed) continue
        for (let j = 0; j < idea.options.length; j++) {
          const option = idea.options[j]
          if (option.purchased) {
            total += +option.price
          }
        }
      }
      return (Math.round(total * 100) / 100).toFixed(2)
    },
    completedCount() {
      let total = 0
      if (!this.campaign || !this.campaign.ideas) return 0
      for (let i = 0; i < this.campaign.ideas.length; i++) {
        const idea = this.campaign.ideas[i]
        if (idea.completed) {
          total++
        }
      }
      return total
    },
  },
  methods: {
    mainOption(idea) {
      let options = [...idea.options]
      //main option is has image and has been purchased

      //sort by timestamp (latest first)

      console.log('idea-' + idea.title)
      options = options.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      const options1 = options.filter((o) => o.image_url && o.purchased) //options with image and purchased
      const options2 = options.filter((o) => o.purchased) //options purchased (even if no image)
      const options3 = options.filter((o) => o.image_url) //options with image

      if (options1.length > 0) return options1[0]
      if (options2.length > 0) return options2[0]
      if (options3.length > 0) return options3[0]

      return { image_url: '' }
    },

    async save() {
      //FIXME: we should just udpate whatever chagnes from here (status) to avoid overriding ideas and options...
      let x = await api.apiFetch(`/regalos/campaign`, {
        method: 'POST',
        body: JSON.stringify(this.campaign),
      })
      if (!x.ok) return alert('something failed')
      let j = await x.json()
    },
    goToEdit() {
      this.$router.push(`/regalos/campaign/${this.campaign_id}/edit`)
    },

    async addIdea() {
      const new_id = uuidv4()
      const idea = {
        campaign_id: this.campaign_id,
        id: new_id,
        title: '',
        description: '',
        options: [
          {
            id: uuidv4(),
            title: '',
            price: 0,
            image_url: '',
            purchased: false,
          },
        ],
        upvotes: 0,
        downvotes: 0,
        status: 'pending',
      }
      let x = await api.apiFetch(`/regalos/idea`, {
        method: 'POST',
        body: JSON.stringify(idea),
      })
      if (!x.ok) return alert('something failed')

      let j = await x.json()
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${new_id}/edit`)
    },
    async fetchData() {
      const x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      if (!x.ok) return alert('something failed')
      const j = await x.json()
      //sort ideas by updatedAt desc ->don't do this as triggers watch and unwanted saves.
      //j.ideas = (j.ideas || []).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
      this.campaign = j
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
